import { siteStats, heroWatch, brandWords } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="pt-16 md:pt-20">
      {/* 上疏：首屏留白大，文案优先 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* text-first */}
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50/70 px-3 py-1.5 text-xs md:text-sm text-primary-800">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-primary-500 animate-ping"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-500"></span>
              </span>
              正在同步 · 擦边吃瓜今日更新
            </div>

            <h1 className="mt-6 text-[34px] leading-[1.18] md:text-6xl lg:text-[64px] font-black text-foreground-950 tracking-tight">
              新瓜不隔夜，
              <br />
              <span className="relative inline-block">
                实时跟上不掉队
                <span className="absolute -bottom-2 left-0 h-1.5 w-full rounded-full bg-accent-300"></span>
              </span>
            </h1>

            <p className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-foreground-600">
              从红毯后台到综艺现场，把散落的信息拼成时间线。最新动态、今日更新与实时快讯同步推送，
              <span className="font-semibold text-foreground-800">新瓜上架第一时间送到</span>，盯紧这里就够了。
            </p>

            <div className="mt-9 flex flex-col sm:flex-row items-stretch gap-3">
              <a
                href="#today"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 px-6 py-3 text-sm md:text-base font-semibold hover:bg-primary-600 transition whitespace-nowrap"
              >
                看今日新瓜
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#community"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300/70 bg-background-50 px-6 py-3 text-sm md:text-base font-semibold text-foreground-800 hover:border-secondary-400 hover:text-secondary-900 transition whitespace-nowrap"
              >
                <i className="ri-chat-smile-3-line"></i>
                进围观台聊聊
              </a>
            </div>

            {/* live mini stats */}
            <dl className="mt-10 grid grid-cols-4 gap-3 max-w-xl">
              {[
                { label: "今日快讯", val: siteStats.flashes },
                { label: "今日更新", val: siteStats.updates },
                { label: "正在围观", val: siteStats.online },
                { label: "累计讨论", val: siteStats.fans },
              ].map((s) => (
                <div key={s.label} className="rounded-lg border border-background-200/70 bg-background-100/60 px-3 py-3 text-center">
                  <dd className="text-lg md:text-xl font-black text-foreground-950">{s.val}</dd>
                  <dt className="mt-0.5 text-xs text-foreground-500">{s.label}</dt>
                </div>
              ))}
            </dl>
          </div>

          {/* visual 陪衬 */}
          <div className="lg:col-span-5">
            <div className="relative rounded-2xl bg-background-100/70 border border-background-200/70 overflow-hidden p-1">
              <div className="absolute inset-x-8 top-6 h-px bg-background-200"></div>
              <div className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden">
                {/* head */}
                <div className="flex items-center justify-between px-4 md:px-5 pt-4 pb-3">
                  <div className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                    <span className="w-6 h-6 rounded-md bg-accent-500 text-background-50 flex items-center justify-center text-xs"><i className="ri-flashlight-line"></i></span>
                    本场围观
                  </div>
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-2.5 py-1 text-xs font-semibold">
                    <i className="ri-hotspot-line"></i> 热度 428w
                  </span>
                </div>
                {/* body quote */}
                <div className="px-4 md:px-5 py-2">
                  <p className="font-serif text-lg md:text-xl leading-relaxed text-foreground-800">
                    「档期定了，会第一时间说。」
                  </p>
                </div>
                {/* status row */}
                <div className="px-4 md:px-5 pb-4">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-2.5 py-1 text-xs font-semibold">
                    <i className="ri-flashlight-fill"></i> {heroWatch.tag} · {heroWatch.time}
                  </span>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                    {heroWatch.text}
                  </p>
                </div>
                {/* visual track */}
                <div className="flex items-center justify-between border-t border-background-200/60 px-4 md:px-5 py-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5"><i className="ri-eye-line"></i> 围观 3.4w</span>
                  <span className="inline-flex items-center gap-1.5"><i className="ri-arrow-up-double-line"></i> 讨论 2.1w</span>
                  <a href="#hot" className="inline-flex items-center gap-1 text-primary-700 hover:text-primary-800 font-medium whitespace-nowrap">
                    看完整时间线 <i className="ri-arrow-right-s-line"></i>
                  </a>
                </div>
              </div>
            </div>
            {/* decorative strip note */}
            <p className="mt-4 text-xs text-foreground-400 flex items-center gap-2">
              <i className="ri-quill-pen-line"></i>
              {brandWords.note}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}